import { defineMessages } from 'react-intl';

export default defineMessages({
    TWIAWizardModalCancelTitle: {
       id: 'tfpa.quoteandbind.wizard.residential.TWIA.Modal.Cancel title',
        defaultMessage: 'Are you sure you want to exit?',
    },
    TWIAWizardModalCancelDescription: {
       id: 'tfpa.quoteandbind.wizard.residential.TWIA.Modal.Cancel description',
        defaultMessage: 'The information you entered will be stored as a draft quote. You must complete and submit this quote within 30 days of its Effective Date, or it will expire.',
    },
    TWIAWizardModalTitle: {
       id: 'tfpa.quoteandbind.wizard.residential.TWIA.Modal.Title',
        defaultMessage: 'Leave Page?',
    },
    TWIAWizardModalMessage: {
       id: 'tfpa.quoteandbind.wizard.residential.TWIA.Modal.Message',
        defaultMessage: 'The changes you have made on this page may be lost.',
    },
    TWIAWizardModalCancel: {
       id: 'tfpa.quoteandbind.wizard.residential.TWIA.Modal.Cancel',
        defaultMessage: 'Cancel',
    },
    TWIAWizardModalConfirm: {
       id: 'tfpa.quoteandbind.wizard.residential.TWIA.Modal.Confirm',
        defaultMessage: 'Yes',
    },
    TWIAQuoteTitle: {
       id: 'tfpa.quoteandbind.wizard.residential.TWIA.title',
        defaultMessage: 'Quote Request',
    },
    TFPAPolicyChangeTitle: {
        id: 'tfpa.policyChange.wizard.residential.TFPA.title',
         defaultMessage: 'Policy Change',
     },
    TFPACommonErrorMessage: {
        id: 'tfpa.quoteandbind.wizard.common.modal.tfpaCommonErrorMessage',
        defaultMessage: 'An error occurred while attempting to save. You may exit the transaction \nand try again. If you continue to receive this error please contact TFPA at \n(800) 979-6440',
    },
    TFPAQuoteErrorMessage: {
        id: 'tfpa.quoteandbind.wizard.common.modal.tfpaQuoteErrorMessage',
        defaultMessage: 'An error occurred while attempting to quote. You may exit the transaction \nand try again. If you continue to receive this error please contact TFPA at \n(800) 979-6440.',
    },
    unableToQuote: {
        id: 'quoteandbind.wizard.common.TFPA.Modal.unableToQuote',
        defaultMessage: 'Unable To Quote',
    },
    TFPARenewalTitle: {
        id: 'tfpa.quoteandbind.wizard.residential.TFPA.title.Renewal',
         defaultMessage: 'Renewal',
     },
})